import React from "react";
import { NumberInputProps } from "./number-input.type";
import { TextField } from "@mui/material";

type NumberalMap = { [key: string]: string };

export const convertNumbers = (input: string) => {
  const numeralMap: NumberalMap = {
    // Arabic numerals
    "٠": "0",
    "١": "1",
    "٢": "2",
    "٣": "3",
    "٤": "4",
    "٥": "5",
    "٦": "6",
    "٧": "7",
    "٨": "8",
    "٩": "9",
    // Persian numerals
    "۰": "0",
    "۱": "1",
    "۲": "2",
    "۳": "3",
    "۴": "4",
    "۵": "5",
    "۶": "6",
    "۷": "7",
    "۸": "8",
    "۹": "9",
    // English numerals
    "0": "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
  };

  return (
    input
      ?.replace(/[\d٠-٩۰-۹]/g, (match) => numeralMap[match] || match)
      ?.replace(/[^\d]/g, "") || ""
  );
};
export const NumberInput = ({ className, ...props }: NumberInputProps) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    e.target.value = convertNumbers(e.target.value);
    if (props.onChange) props.onChange(e);
  };

  return (
    <TextField
      className={`${className || ""} styled-field`}
      {...props}
      onChange={handleChange}
    />
  );
};
